import React from "react";

const ErrorMsg = ({ children }) => {
    return <span className="text-red-500 block">{children}</span>;
};

export default ErrorMsg;
